import { appstr } from "@coreapp/utils/appstr";
import { Button, Flex } from "@theorgchartdev/storybook";
import { CurrentPlanFieldsModal } from "../../PlanFieldsModal";
import { GetWSMgr } from "@/Utils/StateLib";
import { ComponentProps, useRef } from "react";
import BasicInfoSection from "./BasicInfoSection";

type AdditionalInfoSectionProps = ComponentProps<typeof BasicInfoSection> & {
  canManageFields?: boolean;
};

const AdditionalInfoSection = (props: AdditionalInfoSectionProps) => {
  const fieldsHandleRef = useRef<any>(null);
  const wsMgr = GetWSMgr();
  const planMgr = wsMgr?.GetPlanMgr();
  if (!planMgr) return null;

  let controlsNode = null;
  controlsNode = (
    <Flex direction={"row"} justifyContent={"center"} width={"100%"} margin={"8px 0 0 0"}>
      <Button
        dataTestId={"plan-manage-additional-fields"}
        size={"medium"}
        modifier={"secondary"}
        disabled={!props?.canManageFields}
        onClick={() => {
          fieldsHandleRef.current?.handleOpen();
        }}
      >
        {appstr("Manage plan fields")}
      </Button>
    </Flex>
  );

  return (
    <Flex direction="column" gap={"4px"} alignItems="flex-start">
      <BasicInfoSection dataTestIdPrefix={"additional-info-section"} {...props} padding={"0"} />
      {controlsNode}
      <CurrentPlanFieldsModal handleRef={fieldsHandleRef} planMgr={planMgr} />
    </Flex>
  );
};

export default AdditionalInfoSection;
